import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import EmployeeObjectiveServices from "./EmployeeObjective.services";
import { ResponsiveEmbed } from "react-bootstrap";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const resetEmployeeObjective = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE,
      payload: true,
    });
    dispatch({
      type: actions.GET_EMPLOYEE_OBJECTIVE,
      payload: {
        employeeObjectives: [],
        employeeObjectivesLength: 0,
      },
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.EMPLOYEE_OBJECTIVE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE,
      payload: false,
    });
  }
};

export const getEmployeeObjective = (filters) => async (dispatch) => {
  try {

    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE,
      payload: true,
    });
    const resp = await EmployeeObjectiveServices.getEmployeeObjective(filters);
    dispatch({
      type: actions.GET_EMPLOYEE_OBJECTIVE,
      payload: {
        employeeObjectives: resp.data?.data || [],
        employeeObjectivesLength: resp.data?.count || 0,
      },
    });
    dispatch({
      type: actions.EMPLOYEE_OBJECTIVE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.EMPLOYEE_OBJECTIVE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE,
      payload: false,
    });
  }
};

export const getEmployeeObjectiveById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE_BY_ID,
      payload: true,
    });
    const resp = await EmployeeObjectiveServices.getEmployeeObjectiveById(id);
    dispatch({
      type: actions.GET_EMPLOYEE_OBJECTIVE_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.EMPLOYEE_OBJECTIVE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.EMPLOYEE_OBJECTIVE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE_BY_ID,
      payload: false,
    });
  }
};

export const saveEmployeeObjective = (data, setEditingIndex, setIsAdding) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_OBJECTIVE,
      payload: true,
    });
    await EmployeeObjectiveServices.saveEmployeeObjective(data);   
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setEditingIndex(null);
    setIsAdding(false);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_OBJECTIVE,
      payload: false,
    });
  }
};

export const saveMultipleEmployeeObjective = (data, configuracion, evaluacion) => async (dispatch, getState) => {
  debugger
  try {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_OBJECTIVE,
      payload: true,
    });
    let resp = []
    for (const objetivo of data) {
      let req = {
        empleado_evaluacion: Number(evaluacion),
        nombre: objetivo.objetivo,
        pilar_estrategico: Number(objetivo.pilar),
        peso: objetivo.peso,
        indicador: objetivo.indicador,
        configuracion: Number(configuracion)
      }
      const obj = await EmployeeObjectiveServices.saveEmployeeObjective(req)
      resp.push(obj.data);

    }
    const { employeeObjectives, employeeObjectivesLength } = getState().employeeObjective;
    const _employeeObjectives = [...employeeObjectives, ...resp];
    dispatch({
      type: actions.GET_EMPLOYEE_OBJECTIVE,
      payload: {
        employeeObjectives: _employeeObjectives,
        employeeObjectivesLength: employeeObjectivesLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_OBJECTIVE,
      payload: false,
    });
  }
};

export const editEmployeeObjective = (data, id, index, setEditingIndex) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_OBJECTIVE,
      payload: true,
    });
    await EmployeeObjectiveServices.editEmployeeObjective(id, data);
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setEditingIndex(null);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_OBJECTIVE,
      payload: false,
    });
  }
};

export const deleteEmployeeObjective = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE,
      payload: true,
    });
    await EmployeeObjectiveServices.deleteEmployeeObjective(id);
    const { employeeObjectives, employeeObjectivesLength } = getState().employeeObjective;
    employeeObjectives.splice(index, 1);
    dispatch({
      type: actions.GET_EMPLOYEE_OBJECTIVE,
      payload: {
        employeeObjectives: employeeObjectives,
        employeeObjectivesLength: employeeObjectivesLength - 1,
      },
    });
    dispatch({
      type: actions.EMPLOYEE_OBJECTIVE_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data[0]) {
              message = ex.response.data[0];
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE,
      payload: false,
    });
  }
};


export const bossCheckEmployeeObjective = (data, filters) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE,
      payload: true,
    });
    await EmployeeObjectiveServices.bossCheckEmployeeObjective(data);
    const resp = await EmployeeObjectiveServices.getEmployeeObjective(filters);
    dispatch({
      type: actions.GET_EMPLOYEE_OBJECTIVE,
      payload: {
        employeeObjectives: resp.data?.data || [],
        employeeObjectivesLength: resp.data?.count || 0,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });    
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE,
      payload: false,
    });
  }
};

export const approveObjectives = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE,
      payload: true,
    });
    await EmployeeObjectiveServices.approveObjectives(data);
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });    
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE,
      payload: false,
    });
  }
};

export const rejectObjectives = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE,
      payload: true,
    });
    await EmployeeObjectiveServices.rejectObjectives(data);    
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });    
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE,
      payload: false,
    });
  }
};

export const bossRequireMidYearEdit = (data, id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE,
      payload: true,
    });
    await EmployeeObjectiveServices.bossRequireMidYearEdit(data, id);
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });    
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE,
      payload: false,
    });
  }
};

export const bossApprovesMidYear = (data, id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE,
      payload: true,
    });
    await EmployeeObjectiveServices.bossApprovesMidYear(data, id);
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });    
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE,
      payload: false,
    });
  }
};

export const requireActionPlanMidYear = (data, id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE,
      payload: true,
    });
    await EmployeeObjectiveServices.requireActionPlanMidYear(data, id);
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });    
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE,
      payload: false,
    });
  }
};

export const sendFinalEvaluation = (data, id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE,
      payload: true,
    });
    await EmployeeObjectiveServices.sendFinalEvaluation(data, id);
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });    
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_OBJECTIVE,
      payload: false,
    });
  }
};

export const setObjectivesModified = (value) => async (dispatch) => {
  dispatch({
    type: actions.SET_OBJECTIVES_MODIFIED,
    payload: value,
  });
}